import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterLink, ButtonModule, TranslateModule],
  template: `
    <div class="not-found">
      <p class="not-found__code">404</p>
      <h1>{{ 'PAGE_NOT_FOUND_TITLE' | translate }}</h1>
      <p class="not-found__desc">{{ 'PAGE_NOT_FOUND_DESC' | translate }}</p>

      <a routerLink="/" pButton icon="pi pi-home">{{ 'GO_HOME' | translate }}</a>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .not-found {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: var(--ef-s-3);
        min-height: 70vh;
        max-width: 480px;
        margin: 0 auto;
        padding: var(--ef-s-6) var(--ef-s-4);
        text-align: center;

        &__code {
          margin: 0;
          font-size: 0.8125rem;
          font-weight: 600;
          letter-spacing: 0.1em;
          color: var(--ef-primary);
        }

        &__desc {
          margin: 0 0 var(--ef-s-3);
          color: var(--ef-text-muted);
        }

        h1 {
          margin: 0;
          font-size: clamp(1.5rem, 1.2rem + 1.5vw, 2rem);
          font-weight: 700;
          letter-spacing: -0.02em;
        }

        a {
          text-decoration: none;
        }
      }
    `
  ]
})
export class NotFoundComponent {}
